import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { VariantProvider } from "@/context/VariantContext";
import Home from "@/pages/Home";

function App() {
  return (
    <VariantProvider>
      <div className="App">
        <Toaster position="top-center" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </div>
    </VariantProvider>
  );
}

export default App;
